import { render, staticRenderFns } from "./ni-icon-trash.vue?vue&type=template&id=8b92a27a"
import script from "./ni-icon-trash.vue?vue&type=script&lang=js"
export * from "./ni-icon-trash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports